import ActionListener from "@cirrus/legacy/app-common/alt/framework/actionListenerV2.es6"

export const actionListener = new ActionListener()
